const f = (a, b) => [].concat(...a.map(ai => b.map(bi => ai.concat([bi]))));
const cartesian = (...arrays) => arrays.reduce((a, b) => f(a, b), [[]]);

export default cartesian;
